var ViewportType;
(function (ViewportType) {
    ViewportType["STACK"] = "stack";
    ViewportType["ORTHOGRAPHIC"] = "orthographic";
    ViewportType["PERSPECTIVE"] = "perspective";
    ViewportType["VOLUME_3D"] = "volume3d";
    ViewportType["VIDEO"] = "video";
    ViewportType["WHOLE_SLIDE"] = "wholeSlide";
})(ViewportType || (ViewportType = {}));
export default ViewportType;
